export const ENDPOINT = `https://${process.env.NEXT_PUBLIC_PROMOTION_GATEWAY_DOMAIN_NAME}`;
